// extracted by mini-css-extract-plugin
export var email = "SocialLinks-module--email--8c4ec";
export var facebook = "SocialLinks-module--facebook--3b031";
export var instagram = "SocialLinks-module--instagram--05ad0";
export var linkedIn = "SocialLinks-module--linkedIn--15c07";
export var socialIcon = "SocialLinks-module--socialIcon--ab670";
export var twitter = "SocialLinks-module--twitter--aebd8";
export var wrapper = "SocialLinks-module--wrapper--360b8";